import { reviews } from "@/data/siteConfig";
import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { ReviewCard } from "@/components/ReviewCard";
import { ContactCTA } from "@/components/home/ContactCTA";
import { RevealGroup, RevealItem } from "@/components/Reveal";

export default function Reviews() {
  return (
    <>
      <Seo
        title="Customer Reviews"
        description="Read real customer reviews for Velasco Lock and Safe — praised for difficult safe openings, heavy safe moving and honest, professional service across Southern California."
        path="/reviews"
      />
      <PageHero
        overline="Reviews"
        title="Real words from real customers"
        description="Feedback from customers across Southern California, kept faithful to what they wrote. More reviews are added over time."
      />

      <section className="bg-ink py-24 md:py-28">
        <div className="mx-auto max-w-[1440px] px-5 md:px-8">
          <RevealGroup className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {reviews.map((r, i) => (
              <RevealItem key={i}>
                <ReviewCard review={r} />
              </RevealItem>
            ))}
          </RevealGroup>
          <p className="mt-12 text-center text-sm text-steel/70">
            More customer reviews will be added here. Had a great experience? Mention it
            when you call.
          </p>
        </div>
      </section>

      <ContactCTA />
    </>
  );
}
